import React from 'react';
import { Handle, Position } from '@xyflow/react';

function KeyVaultNode({ data, selected }) {
  return (
    <div
      className={`relative rounded-lg border-2 p-3 transition-colors ${
        selected
          ? 'border-green-600 bg-green-50/70 dark:bg-green-900/30'
          : 'border-green-400 bg-green-50/40 dark:bg-green-900/20'
      }`}
      style={{ width: 220, height: 120 }}
    >
      <Handle type="target" position={Position.Top} className="!bg-green-600" />
      <div className="mb-1 flex items-center gap-2">
        <svg className="h-4 w-4 text-green-700 dark:text-green-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        <span className="text-sm font-semibold text-green-900 dark:text-green-100 truncate">{data.name}</span>
      </div>
      {data.kvSku && (
        <span className="inline-block bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.kvSku}
        </span>
      )}
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Key Vault</div>
      <Handle type="source" position={Position.Bottom} className="!bg-green-600" />
    </div>
  );
}

export default KeyVaultNode;
